import { Component } from '@angular/core';

@Component({
    selector: 'app-unauthorized',
    standalone: true,
    imports: [],
    templateUrl: './unauthorized.component.html',
    styleUrl: './unauthorized.component.scss',
})
export class UnauthorizedComponent {}
